<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-08-01 17:51:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-08-02 10:41:56
-->
<template>
  <div class="con-wrap">
    <Add :accountType="accountType" />
  </div>
</template>

<script>
import Add from "@/components/RegionAccount/Add";
export default {
  name: "AddCity",
  components: { Add },
  data() {
    return {
      accountType: "city",
    };
  },
};
</script>
<style lang="scss" scoped>
.con-wrap {
  overflow: auto;
}
</style>
